import React from 'react';
import styled from 'styled-components';
import { useHover } from '@logz-pkg/react-hooks';
import { space } from '../utils';

const propTypes = {
  ...space.propTypes,
};

const HeaderDropdownStyled = styled.div`
  display: flex;
  position: relative;
  ${space};
`;

/**
 * @deprecated
 */
export const HeaderDropdown = ({ p = 0, m = 0, ...props }) => {
  const { ref, isHovering } = useHover();

  return (
    <IsHoveredContext.Provider value={isHovering}>
      <HeaderDropdownStyled p={p} m={m} {...props} ref={ref} />
    </IsHoveredContext.Provider>
  );
};

export const IsHoveredContext = React.createContext(false);

HeaderDropdown.propTypes = propTypes;
